import { createAction } from "@reduxjs/toolkit";
import axios from "axios";
import {
  FETCH_CONTACT_ASSET_ANALYTICS_REQUEST,
  FETCH_CONTACT_REQUEST,
  FETCH_CONTACT_SHARE_SECTION_REQUEST,
  FETCH_CONTENTS_FOR_SHARE,
  FETCH_SHARES_FOR_CONTACT_REQUEST,
  FETCHING_CONTACT_ASSET_ANALYTICS_FAILED,
  FETCHING_CONTACT_ASSET_ANALYTICS_SUCCEEDED,
  FETCHING_CONTACT_FAILED,
  FETCHING_CONTACT_SHARE_SECTION_FAILED,
  FETCHING_CONTACT_SHARE_SECTION_SUCCEEDED,
  FETCHING_CONTACT_SUCCEEDED,
  FETCHING_CONTENTS_FOR_SHARE_FAILED,
  FETCHING_CONTENTS_FOR_SHARE_SUCCEEDED,
  FETCHING_SHARES_FOR_CONTACT_REQUEST_SUCCEEDED,
  INVALIDATE_CONTACT_UPDATIONS,
  UPDATE_CONTACT_REQUEST,
  UPDATING_CONTACT_FAILED,
  UPDATING_CONTACT_SUCCEEDED,
} from "./actionTypes";
import {
  FetchAssetAnalyticsForContactRequest,
  FetchContactRequest,
  FetchContactShareSectionRequest,
  FetchContentsForShareRequest,
  FetchingAssetAnalyticsForContactFailed,
  FetchingAssetAnalyticsForContactSucceeded,
  FetchingContactFailed,
  FetchingContactShareSectionFailed,
  FetchingContactShareSectionSucceeded,
  FetchingContactSucceeded,
  FetchingContentsForShareFailed,
  FetchingContentsForShareSucceeded,
  FetchingSharesForContactFailed,
  FetchingSharesForContactSucceeded,
  FetchSharesForContactRequest,
  updateContactRequest,
  updatingContactFailed,
  updatingContactSucceeded,
} from "src/types/contact";
import { call, put, takeEvery } from "redux-saga/effects";
import buildUrl from "build-url-ts";

// eslint-disable-next-line no-undef
const apiurl = process.env.REACT_APP_API_URL;
export const CONTACTS_BASE_URL = `${apiurl}/api/2.0/contacts`;

export const fetchContact = createAction<FetchContactRequest>(
  FETCH_CONTACT_REQUEST,
);
const fetchingContactSucceeded = createAction<FetchingContactSucceeded>(
  FETCHING_CONTACT_SUCCEEDED,
);
const fetchingContactFailed = createAction<FetchingContactFailed>(
  FETCHING_CONTACT_FAILED,
);

const fetchContactSaga = function* (action: ReturnType<typeof fetchContact>) {
  const { id } = action.payload;
  const fetchContactApi = () => {
    const url = buildUrl(CONTACTS_BASE_URL, {
      path: `${id}`,
    });

    return axios({
      method: "GET",
      url: url,
    }).then((response) => {
      return response.data;
    });
  };
  try {
    const response = yield call(fetchContactApi);
    yield put(
      fetchingContactSucceeded({
        id,
        response,
      }),
    );
  } catch (error) {
    yield put(
      fetchingContactFailed({
        id,
        error,
      }),
    );
  }
};

export const fetchSharesForContact = createAction<FetchSharesForContactRequest>(
  FETCH_SHARES_FOR_CONTACT_REQUEST,
);
const fetchingContactSharesSucceeded =
  createAction<FetchingSharesForContactSucceeded>(
    FETCHING_SHARES_FOR_CONTACT_REQUEST_SUCCEEDED,
  );
const fetchingContactSharesFailed =
  createAction<FetchingSharesForContactFailed>(FETCHING_CONTACT_FAILED);

const fetchSharesForContactSaga = function* (
  action: ReturnType<typeof fetchSharesForContact>,
) {
  const { id, page } = action.payload;
  const params = {
    page,
  };
  const fetchContactSharesApi = () => {
    const url = buildUrl(CONTACTS_BASE_URL, {
      path: `${id}/shares`,
    });
    return axios({
      method: "GET",
      url: url,
      params: params,
    }).then((response) => {
      return response.data;
    });
  };
  try {
    const response = yield call(fetchContactSharesApi);
    yield put(
      fetchingContactSharesSucceeded({
        id,
        response,
      }),
    );
  } catch (error) {
    yield put(
      fetchingContactSharesFailed({
        id,
        error,
      }),
    );
  }
};

export const fetchContentsForShare = createAction<FetchContentsForShareRequest>(
  FETCH_CONTENTS_FOR_SHARE,
);
const fetchContentsForShareSucceeded =
  createAction<FetchingContentsForShareSucceeded>(
    FETCHING_CONTENTS_FOR_SHARE_SUCCEEDED,
  );
const fetchContentsForShareFailed =
  createAction<FetchingContentsForShareFailed>(
    FETCHING_CONTENTS_FOR_SHARE_FAILED,
  );

const fetchContentsForShareSaga = function* (
  action: ReturnType<typeof fetchContentsForShare>,
) {
  const { shareId, contactId } = action.payload;

  const fetchContentsForShareApi = () => {
    const url = buildUrl(CONTACTS_BASE_URL, {
      path: `/${contactId}/shares/${shareId}`,
    });

    return axios({
      method: "GET",
      url: url,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchContentsForShareApi);
    yield put(
      fetchContentsForShareSucceeded({
        shareId,
        contactId,
        response,
      }),
    );
  } catch (error) {
    yield put(
      fetchContentsForShareFailed({
        shareId,
        contactId,
        error,
      }),
    );
  }
};

export const fetchAssetAnalayticsForContact =
  createAction<FetchAssetAnalyticsForContactRequest>(
    FETCH_CONTACT_ASSET_ANALYTICS_REQUEST,
  );
const fetchAssetAnalyticsForContactSucceeded =
  createAction<FetchingAssetAnalyticsForContactSucceeded>(
    FETCHING_CONTACT_ASSET_ANALYTICS_SUCCEEDED,
  );
const fetchAssetAnalyticsForContactFailed =
  createAction<FetchingAssetAnalyticsForContactFailed>(
    FETCHING_CONTACT_ASSET_ANALYTICS_FAILED,
  );

export const fetchAssetAnalyticsForContactSaga = function* (
  action: ReturnType<typeof fetchAssetAnalayticsForContact>,
) {
  const { shareId, contactId, assetId, sectionId } = action.payload;

  const fetchAssetAnalyticsForContactApi = () => {
    const url = buildUrl(CONTACTS_BASE_URL, {
      path: `${contactId}/shares/${shareId}/assets/${assetId}/analytics`,
    });
    return axios({
      method: "GET",
      url: url,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchAssetAnalyticsForContactApi);
    yield put(
      fetchAssetAnalyticsForContactSucceeded({
        shareId,
        contactId,
        assetId,
        sectionId,
        analytics: response,
      }),
    );
  } catch (error) {
    yield put(
      fetchAssetAnalyticsForContactFailed({
        shareId,
        contactId,
        assetId,
        sectionId,
        error,
      }),
    );
  }
};

export const fetchContactSections = createAction<FetchContactShareSectionRequest>(
  FETCH_CONTACT_SHARE_SECTION_REQUEST
)
const fetchContactSectionsSucceeded = createAction<FetchingContactShareSectionSucceeded>(FETCHING_CONTACT_SHARE_SECTION_SUCCEEDED)
const fetchContactSectionsFailed = createAction<FetchingContactShareSectionFailed>(FETCHING_CONTACT_SHARE_SECTION_FAILED)

export const fetchContactSectionsSaga = function* (action: ReturnType<typeof fetchContactSections>) {
  const { sectionId, contactId, shareId } = action.payload;
  const fetchContactSectionsApi = () => {
    const url = buildUrl(CONTACTS_BASE_URL, {
      path: `/${contactId}/sections/${sectionId}`,
    })
    return axios({
      method: "GET",
      url: url,
    }).then((response) => response.data)
}
try {
  const response = yield call(fetchContactSectionsApi);
  yield put(fetchContactSectionsSucceeded({
    sectionId,
    contactId,
    shareId,
    response,
  }))
} catch (error) {
  yield put (fetchContactSectionsFailed({
    sectionId,
    contactId,
    shareId,
    error,
  }))
}
}

export const updateContact = createAction<updateContactRequest>(UPDATE_CONTACT_REQUEST)
const updateContactSucceeded = createAction<updatingContactSucceeded>(UPDATING_CONTACT_SUCCEEDED)
const updateContactFailed = createAction<updatingContactFailed>(UPDATING_CONTACT_FAILED)
export const invalidateContactUpdations = createAction<void>(INVALIDATE_CONTACT_UPDATIONS)

export function* updateContactSaga(action: ReturnType<typeof updateContact>) {
  const { id, request } = action.payload;
  const updateContactApi = () => {
    const url = buildUrl(CONTACTS_BASE_URL, {
      path: `${id}`,
    })
  return axios({
    method: "PUT",
    url,
    data: request,
  }).then((response) => response.data)
  }

  try {
    const response = yield call(updateContactApi)
    yield put(updateContactSucceeded({
      id,
      response,
    }))
  } catch (error) {
    yield put(updateContactFailed({
      id,
      error,
    }))
  }
}

export default function* contactSaga() {
  yield takeEvery(FETCH_CONTACT_REQUEST, fetchContactSaga);
  yield takeEvery(FETCH_SHARES_FOR_CONTACT_REQUEST, fetchSharesForContactSaga);
  yield takeEvery(FETCH_CONTENTS_FOR_SHARE, fetchContentsForShareSaga);
  yield takeEvery(
    FETCH_CONTACT_ASSET_ANALYTICS_REQUEST,
    fetchAssetAnalyticsForContactSaga,
  );
  yield takeEvery(FETCH_CONTACT_SHARE_SECTION_REQUEST, fetchContactSectionsSaga);
  yield takeEvery(UPDATE_CONTACT_REQUEST, updateContactSaga)
}